


































































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import axios from "axios";
const instance = axios.create({
  // headers: {'X-Custom-Header': 'foobar'}
});
import RtRadio from "@/components/base/RtRadio.vue";
import DateSelect from "@/components/coupon/DateSelect.vue";

const couponModule = namespace("coupon");

@Component({
  components: {
    RtRadio,
    DateSelect
  }
})
export default class CouponAdd extends Vue {
  @couponModule.Getter("CATEGORY") CATEGORY!: Array<any>;
  @couponModule.Getter("CATEGORY_VALUE") CATEGORY_VALUE!: any;
  minDate: Date = new Date();

  form = {
    couponCategoryId: "", //券类型
    couponName: "", //券名称
    couponDiscount: "", //折扣
    couponMainInfo: "", //主标题
    couponExtendInfo: "", //副标题
    couponDisplayTimeSwitch: 0, //展示有效期开关
    couponDisplayStartTime: "", //展示有效期
    couponDisplayEndTime: "", //展示有效期
    couponGetStartTime: "", //领取有效期
    couponGetEndTime: "", //领取有效期
    couponGetTimeLimitSwitch: 0, //领取时段限制开关
    getTimeLimitWeekList: [], //领取时段限制周
    getTimeLimitTimeList: [
      {
        startTime: "08:00",
        endTime: "09:00"
      }
    ], //领取时段限制时间段
    couponEffectiveSwitch: 0, //核销有效日期类型
    couponEffectiveStartTime: "", //核销有效开始日期
    couponEffectiveEndTime: "", //核销有效结束日期
    couponActivedLimitedStartDay: "0", //领取后多少天生效
    couponActivedLimitedDays: "1", //领取后有效天数
    couponEffectiveTimeLimitSwitch: 0, //
    effectiveTimeLimitWeekList: [], //
    effectiveTimeLimitTimeList: [
      {
        startTime: "08:00",
        endTime: "09:00"
      }
    ], //
    couponEffectiveConditionSwitch: 0, //门槛开关
    couponEffectiveConditionPrice: "", //门槛(金额)
    couponQuantity: "", //券数量
    couponFacePrice: "", //券金额
    couponUnitPrice: "", //原价
    couponCost: "", //成本
    couponDayLimitNumSwitch: 0, //每人每天领取限制开关
    couponDayLimitNum: "", //每人每天领取限制数
    couponCumulativeLimitNumSwitch: 0, //每人累计领取限制开关
    couponCumulativeLimitNum: "", //每人累计领取限制数
    couponMarginWarningSwitch: 0, //券余量预警开关
    couponMarginWarningQuantity: 0, //劵余量预警数
    couponDescClause: "", //使用说明
    imageInfoVoList: [
      {
        img: "",
        html: ""
      }
    ],
    photoUriList: Array<{ url: string }>()
  };
  imageInfoVoListIndex = 0;

  list = [
    { label: "周一", value: "1" },
    { label: "周二", value: "2" },
    { label: "周三", value: "3" },
    { label: "周四", value: "4" },
    { label: "周五", value: "5" },
    { label: "周六", value: "6" },
    { label: "周日", value: "7" }
  ];
  result = ["a", "b"];
  showOption = [{ label: "不限", value: 0 }, { label: "自定义时间", value: 1 }];
  showOptions = [
    { label: "不限", value: 0 },
    { label: "自定义预警", value: 1 }
  ];
  writeOption = [
    { label: "选择时间", value: 0 },
    { label: "领取后有效", value: 1 }
  ];
  limitption = [{ label: "不限", value: 0 }, { label: "指定张数", value: 1 }];
  useOption = [{ label: "无门槛", value: 0 }, { label: "门槛", value: 1 }];
  typeText = "";
  showPicker = false;
  columns = ["杭州", "宁波", "温州", "嘉兴", "湖州"];
  get action() {
    return this.$http["FILE_UPLOAD"].api;
  }

  setCouponActivedLimitedDays(e: any) {
    console.log(e);
    if (e.data && e.data <= 0) {
      this.form.couponActivedLimitedDays = "1";
    }
  }

  addGetTime() {
    this.form.getTimeLimitTimeList.push({
      startTime: "08:00",
      endTime: "09:00"
    });
  }

  deleteGetTime(index: any) {
    this.form.getTimeLimitTimeList.splice(index, 1);
  }

  addEffectiveTime() {
    this.form.effectiveTimeLimitTimeList.push({
      startTime: "08:00",
      endTime: "09:00"
    });
  }

  deleteEffectiveTime(index: any) {
    this.form.effectiveTimeLimitTimeList.splice(index, 1);
  }

  del(url: any) {
    let index = this.form.photoUriList.indexOf(url);
    this.form.photoUriList.splice(index, 1);
  }
  delfo(url: any) {
    // debugger;
    let index = this.form.photoUriList.indexOf(url);
    this.form.imageInfoVoList.splice(index, 1);
  }
  onConfirm(value: any) {
    this.typeText = value.label;
    this.form.couponCategoryId = value.value;
    this.showPicker = false;
  }
  async uploader(val: any) {
    const param = new FormData();
    param.append("file", val.file);

    instance
      .post(this.action, param, {
        headers: {
          "Content-Type": "multipart/form-data",
          token: this.$global.token,
          tenantId: this.$global.tenantId,
          tenantType: this.$global.tenantType
        }
      })
      .then(res => {
        this.form.photoUriList.push({ url: res.data.data.path });
      });
  }
  addImgText() {
    this.form.imageInfoVoList.push({
      img: "",
      html: ""
    });
  }
  filteremoji(emojireg: any) {
    const ranges = [
      "\ud83c[\udf00-\udfff]",
      "\ud83d[\udc00-\ude4f]",
      "\ud83d[\ude80-\udeff]"
    ];
    return (emojireg = emojireg.replace(new RegExp(ranges.join("|"), "g"), ""));
  }
  uploaderImg(val: any, index: any) {
    //图文图片上传
    console.log(index);
    const param = new FormData();
    param.append("file", val.file);
    instance
      .post(this.action, param, {
        headers: {
          "Content-Type": "multipart/form-data",
          token: this.$global.token,
          tenantId: this.$global.tenantId,
          tenantType: this.$global.tenantType
        }
      })
      .then(res => {
        this.form.imageInfoVoList[this.imageInfoVoListIndex].img =
          res.data.data.path;
      });
  }
  uploaderImgClick(index: any) {
    this.imageInfoVoListIndex = index;
  }

  async creat() {
    if (this.form.photoUriList.length == 0) {
      return (this as any).$notify({ title: "", message: "请上传封面图片" });
    }
    if (this.form.couponEffectiveSwitch == 1) {
      if (
        !this.form.couponActivedLimitedDays ||
        this.form.couponActivedLimitedDays < "1"
      ) {
        return (this as any).$notify({ title: "", message: "有效期最少一天" });
      }
    }

    if (
      Number(this.form.couponDiscount) < 10 &&
      this.form.couponCategoryId == this.CATEGORY_VALUE.DISCOUNT
    ) {
      return (this as any).$notify({
        title: "",
        message: "请输入正确的折扣百分比"
      });
    }

    this.form.imageInfoVoList.map((item: any) => {
      //couponDescClause
      item.html = this.filteremoji(item.html);
      return item.html;
    });
    this.form.couponDescClause = this.filteremoji(this.form.couponDescClause);
    let params = JSON.parse(JSON.stringify(this.form));
    const { error, success }: any = await this.$store.dispatch(
      "coupon/addCoupon",
      params
    );
    if (success) {
      (this as any).$notify({ type: "success", message: success.msg });
      this.$router.push("/coupon/list");
    }
    error && (this as any).$notify(error.msg);
  }

  createHandler() {
    this.$router.push("/coupon/list");
  }
  mounted() {
    this.$store.dispatch("coupon/getCategoryList");
  }
}
